// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/enterprise-admin/organization/FrameworkStrategySection.jsx

import React from "react";
import { Field, Select, TextInput } from "../../../design-system/components";
import GuidedMultiSelect from "./GuidedMultiSelect";
import OrganizationSectionCard from "./OrganizationSectionCard";

const FRAMEWORKS = [
  "SOC2",
  "NIST",
  "ISO 27001",
  "HIPAA",
  "FedRAMP",
  "CCPA",
  "AML/KYC",
  "PCI DSS",
  "GDPR",
  "FDA",
  "OSHA",
];

function fromCsv(value) {
  return String(value || "")
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
}

export default function FrameworkStrategySection({ draft, setField }) {
  return (
    <OrganizationSectionCard
      eyebrow="Framework strategy"
      title="Compliance framework direction"
      description="Define the frameworks OASYS should prioritize and the operating approach behind them."
    >
      <div className="enterprise-admin-organization-fields">
        <div className="enterprise-admin-organization-field-wide">
          <GuidedMultiSelect
            label="Selected frameworks"
            value={fromCsv(draft.selected_frameworks_csv)}
            options={FRAMEWORKS}
            onChange={(items) => setField("selected_frameworks_csv", items.join(", "))}
            placeholder="Select compliance frameworks"
            helper="Choose from the catalog or add another framework."
          />
        </div>

        <Field label="Strategy approach">
          <Select
            value={draft.framework_strategy_approach || ""}
            onChange={(event) =>
              setField("framework_strategy_approach", event.target.value)
            }
          >
            <option value="">Select approach</option>
            <option value="continuous">Continuous compliance</option>
            <option value="audit_readiness">Audit readiness</option>
            <option value="risk_reduction">Risk reduction</option>
            <option value="customer_assurance">Customer assurance</option>
          </Select>
        </Field>

        <Field label="Audit target date" optionalLabel="Optional">
          <TextInput
            type="date"
            value={draft.audit_target_date || ""}
            onChange={(event) => setField("audit_target_date", event.target.value)}
          />
        </Field>
      </div>
    </OrganizationSectionCard>
  );
}
